/* tslint:disable */
/* eslint-disable */
/**
 * User service API
 * Service for user management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfirmResponse
 */
export interface ConfirmResponse {
    /**
     * User Id
     * @type {string}
     * @memberof ConfirmResponse
     */
    userId?: string;
    /**
     * User's email.
     * @type {string}
     * @memberof ConfirmResponse
     */
    email?: string;
    /**
     * Mode of onboarding: is user joining already existing org or not?
     * @type {boolean}
     * @memberof ConfirmResponse
     */
    join?: boolean;
    /**
     * Was user onboarded?
     * @type {string}
     * @memberof ConfirmResponse
     */
    successCode?: ConfirmResponseSuccessCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof ConfirmResponse
     */
    orgName?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmResponse
     */
    orgDomain?: string;
}


/**
 * @export
 */
export const ConfirmResponseSuccessCodeEnum = {
    UserSignedUp: 'USER_SIGNED_UP',
    UserConfirmed: 'USER_CONFIRMED',
    UserComplete: 'USER_COMPLETE',
    WalletSaved: 'WALLET_SAVED',
    AlreadyConfirmed: 'ALREADY_CONFIRMED',
    AlreadyOnboarded: 'ALREADY_ONBOARDED',
    ResentConfirmationCode: 'RESENT_CONFIRMATION_CODE',
    Ok: 'OK'
} as const;
export type ConfirmResponseSuccessCodeEnum = typeof ConfirmResponseSuccessCodeEnum[keyof typeof ConfirmResponseSuccessCodeEnum];


/**
 * Check if a given object implements the ConfirmResponse interface.
 */
export function instanceOfConfirmResponse(value: object): boolean {
    return true;
}

export function ConfirmResponseFromJSON(json: any): ConfirmResponse {
    return ConfirmResponseFromJSONTyped(json, false);
}

export function ConfirmResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'email': json['email'] == null ? undefined : json['email'],
        'join': json['join'] == null ? undefined : json['join'],
        'successCode': json['successCode'] == null ? undefined : json['successCode'],
        'orgName': json['orgName'] == null ? undefined : json['orgName'],
        'orgDomain': json['orgDomain'] == null ? undefined : json['orgDomain'],
    };
}

export function ConfirmResponseToJSON(value?: ConfirmResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'userId': value['userId'],
        'email': value['email'],
        'join': value['join'],
        'successCode': value['successCode'],
        'orgName': value['orgName'],
        'orgDomain': value['orgDomain'],
    };
}

